export enum OfferOrderFilterEnum {
  Offen= 'Offen',
  InBearbeitung= 'InBearbeitung',
  Online= 'Online',
  Deaktiviert= 'Deaktiviert',
  Offline= 'Offline',
  WaitingOnApproval= 'WaitingOnApproval'
}
